'use client'
import { createChat } from "@/apis/chat"
import { Authentication } from "@/components/AuthenticationLink"
import { useRouter } from "@/locales/routing"
import { DarkButton } from "@/ui/Button"
import { ButtonProps } from "@heroui/react"
import { useMutation } from "@tanstack/react-query"
import { useTranslations } from "next-intl"
import { useParams } from "next/navigation"
import { ReactNode, ComponentProps, useTransition, useMemo } from "react"

type ToChatButtonProps = {
  render?: (verify: () => boolean, onPress: () => void, ...props: any[]) => ReactNode,
  id?: number
} & Omit<ButtonProps, 'id'>



export const useToChat = (wrapperId?) => {
  const {
    mutate,
    data,
    isPending: apiPending,
  } = useMutation({
    mutationFn: createChat
  })
  const router = useRouter()
  const [routeIsPending, startTransition] = useTransition()

  const onPressChat = (id?) => {
    mutate(
      {
        robot_id: Number(id || wrapperId)
      },
      {
        onSuccess(data) {
          if (data.status === 200) {
            startTransition(() => {
              router.push(`/chats/${data.data.session_id}/${data.data.chat_id}`)
            })
          }
        },
      }
    )
  }

  const isPending = useMemo(() => {
    return routeIsPending || apiPending
  }, [routeIsPending, apiPending])
  return {
    data,
    isPending,
    onPressChat
  }
}

export const ToChatButton = ({ render, id, ...props }: ToChatButtonProps) => {
  const params = useParams()
  const { onPressChat,
    isPending } = useToChat(id || params.id)
  const t = useTranslations()

  return (
    <Authentication render={render ?
      (verify) => render(verify, onPressChat, props) :
      (verify: () => boolean) => (
        <DarkButton
          fullWidth
          isLoading={isPending}
          onPress={() => {
            if (verify())
              onPressChat()
          }}
          {...props}
        >
          {t('common.chat')}
        </DarkButton>
      )}>

    </Authentication >

  )
}